// extracted by mini-css-extract-plugin
module.exports = {"fio-suggest":"_3c6ef300a5--fio-suggest--lHkEt","fio-item":"_3c6ef300a5--fio-item--W1Gmd"};